/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Tab_BillInputs */



/**
* | output |
* | --- |
* | "Bill (ERP file)" |
*
* @param {Admin_Export_Tab_BillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_tab_bill = /** @type {((inputs?: Admin_Export_Tab_BillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Tab_BillInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnung (ERP-Datei)")
	return /** @type {LocalizedString} */ ("Bill (ERP file)")
});